import React from 'react';
import PropTypes from 'prop-types';

import TicketListRow from './TicketListRow';

const TicketList = ({tickets}) => {
  return (
    <table className="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Request Summary</th>
          <th className="hide-for-mobiles">Tenant</th>
          <th className="hide-for-mobiles">Requester</th>
          <th>Status</th>
          <th className="hide-for-mobiles">Updated</th>
        </tr>
      </thead>
      <tbody>
      {tickets.map(ticket =>
        <TicketListRow key={ticket.id} ticket={ticket} />
      )}
      </tbody>
    </table>
  );
};

TicketList.propTypes = {
  tickets: PropTypes.array.isRequired
};

export default TicketList;
